<template>
<div id="app">

  <FullNav v-if="this.$route.meta.hideNav != true"></FullNav>

  <nav id="breadcrumbs-container">
    <div class="bc-box">
    <div class="bc"><a href="https://www.openagent.com.au">Home</a></div>
    <div class="ut-mx-1 ut-text-Gnew">></div>
    <div class="bc"><a> Real Estate Agent Reviews</a></div>
      <script type="application/ld+json">
        {
          "@context": "http://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [{
            "@type": "ListItem",
            "position": 1,
            "item": {
              "@id": "https://www.openagent.com.au",
              "name": "OpenAgent"
            }
          }, {
            "@type": "ListItem",
            "position": 2,
            "item": {
              "@id": "https://www.openagent.com.au/real-estate-agent-reviews",
              "name": "Real Estate Agent Reviews"
            }
          }]
        }
      </script>
    </div>
  </nav>

  <transition name="fade" mode="out-in">
    <router-view />
  </transition>

</div>
</template>

<script>
import FullNav from '@/components/FullNav.vue';

export default {
  name: 'Listing',
  components: {
    FullNav
  },
  created() {
  },
}
</script>

<style lang="scss">
@import 'assets/styles/app';

#app {
    font-family: Lato;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    .searchresults {
        list-style: none;
        padding: 0;
        z-index: 1;
    }

    p {
        @apply ut-leading-snug;
    }

    input {
        @apply ut-p-2 ut-my-1 ut-text-sm;
        border: 1px solid #ccc;
        width: 100%;
        border-radius: 4px;
        border-style: solid;
        box-sizing: border-box;

        &:focus {
            @apply ut-border-Gnew;
        }
    }

    .radio-container {
      padding-right: 5px;
      padding-top: 5px;

        &.radio-active {
            .radio-group {
                background-color: #C2EED8;
                box-shadow: unset !important;
            }
        }
        .radio-group {
            @apply ut-cursor-pointer;
            margin: 0;
            background-color: #E6E6E6;
            box-shadow: unset;
            width: fit-content;
        }
    }
}
.required-field > label::after {
    content: '*';
    color: red;
    margin-left: 0.25rem;
}

.hasDanger {
    @apply ut-text-red300 ut-border-red400;
    input {
        border-color: #e48787 !important;
    }
}

.hasSuccess {
    @apply ut-text-G400 ut-border-G400;
}

.fade-enter-active,
.fade-leave-active {
    transition-duration: 0.2s;
    transition-property: opacity;
    transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
    opacity: 0;
}

#breadcrumbs-container {
  display: none;

  @screen lg {
    display: block;
  }

    background-color: #f7f7f8;
    padding: 10px 0;

    .bc-box {
      display: flex;
      justify-content: start;
      max-width: 1120px;
      padding: 0 5%;
    }

    .bc {
      font-weight: bold;
      color: #0FA857;
      margin: 0;
      width: auto;
    }
}
</style>
